import kebabCase from 'lodash/kebabCase';
import React from 'react';
import colors from '../../../../../helpers/colors';
import { generateKeyForElement } from '../../../../../helpers/elementKeyHelper';
import Icon from '../../../../Icon';
import CardSection from '../../../DoubleHeader/CardSection';
import { GridAlignedText } from '../../../commonStyles/commonHeaderStyles';
import {
  isCardSection,
  LinkSection as LinkSectionType,
  NavLink,
  NavSection,
} from '../../../types';
import withOnClick from '../../../withOnClick';
import {
  CardSectionContainer,
  IconWrapper,
  SectionHeading,
  SectionLink,
  SectionLinks,
  SectionLinkWrapper,
} from './styles';

type LinkSectionsProps = NavSection & {
  baseId: string;
  resetNav: () => void;
};

export const getSectionId = (
  baseId: string,
  name: string,
  sectionNumber: number
): string => `${baseId}-${kebabCase(name)}-section-${sectionNumber}`;

type LinkSectionProps = LinkSectionType & {
  id: string;
  sectionNumber: number;
  resetNav: () => void;
};

const LinkSection: React.FC<LinkSectionProps> = ({
  heading,
  links,
  id,
  sectionNumber,
  resetNav,
}) => {
  return (
    <div id={id}>
      {heading && (
        /* We add the `first-section-heading` class to target this element in the MoreThan component theme */
        <SectionHeading
          className={sectionNumber === 0 ? 'first-section-heading' : undefined}>
          <GridAlignedText>{heading}</GridAlignedText>
        </SectionHeading>
      )}
      <SectionLinks>
        {links.map((link: NavLink) => (
          <SectionLinkWrapper key={generateKeyForElement(link)}>
            <SectionLink href={link.url} onClick={withOnClick(link, resetNav).onClick}>
              <GridAlignedText>{link.text}</GridAlignedText>
              <IconWrapper>
                <Icon name={'chevron'} size="small" color={colors.core01} />
              </IconWrapper>
            </SectionLink>
          </SectionLinkWrapper>
        ))}
      </SectionLinks>
    </div>
  );
};

const LinkSections: React.FC<LinkSectionsProps> = ({
  sections,
  name,
  baseId,
  resetNav,
}) => (
  <>
    {sections.map((navSection, i) => {
      if (isCardSection(navSection)) {
        return (
          <CardSectionContainer key={generateKeyForElement(navSection)}>
            <CardSection {...navSection} />
          </CardSectionContainer>
        );
      }
      return (
        <LinkSection
          key={generateKeyForElement(navSection)}
          {...navSection}
          id={getSectionId(baseId, name, i)}
          sectionNumber={i}
          resetNav={resetNav}
        />
      );
    })}
  </>
);

export default LinkSections;
